import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async init ({ dispatch }) {
    try {
      const user = await directus.getMe()
      if (user.data.id !== 1) {
        throw new Error('データ初期化はAdminユーザーのみが実行できます。')
      }
      dispatch('loading/show', null, { root: true })
      await dispatch('remove')
      await dispatch('create')
      dispatch('loading/hide', null, { root: true })
      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}
